import React, { Component } from 'react';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';

/**
 * Controlled pagination. The current page is ALWAYS derived from `pagination.number`
 * (the authoritative 0-based page from the backend), so Prev/Next move relative to the
 * real page rather than a private counter.
 *
 * Previously this kept an internal `state.page` that was never synced to props. Whenever
 * it drifted behind the actual page (after a search/sort, or an auto-reload), Prev/Next
 * computed `state.page ± 1` from the stale counter — so the first click re-loaded the
 * current page and a SECOND click was needed to actually move ("click twice" bug).
 *
 * @param pagination Spring-style page: { number, totalPages, first, last }
 * @param paginate   (pageIndex: number) => void  — called with the target 0-based page
 */
class XMPagination extends Component {
  render() {
    const { pagination, paginate } = this.props;

    if (!pagination || !pagination.totalPages) {
      return null;
    }

    const current = pagination.number || 0;

    return (
      <nav>
        <Pagination>
          {!pagination.first ? (
            <PaginationItem>
              <PaginationLink previous onClick={() => paginate(current - 1)}>
                Prev
              </PaginationLink>
            </PaginationItem>
          ) : null}
          {Array(pagination.totalPages)
            .fill(1)
            .map((el, i) => (
              <PaginationItem key={i} active={current == i}>
                <PaginationLink onClick={() => paginate(i)}>{i + 1}</PaginationLink>
              </PaginationItem>
            ))}
          {!pagination.last ? (
            <PaginationItem>
              <PaginationLink next onClick={() => paginate(current + 1)}>
                Next
              </PaginationLink>
            </PaginationItem>
          ) : null}
        </Pagination>
      </nav>
    );
  }
}

export default XMPagination;
